import { useSyncExternalStore } from 'react'

const subscribe = (onChange: () => void) => {
  window.addEventListener('focus', onChange)
  window.addEventListener('blur', onChange)
  return () => {
    window.removeEventListener('focus', onChange)
    window.removeEventListener('blur', onChange)
  }
}

// Visible is not enough: two windows side by side are both visible, but only one has focus.
export const useWindowFocused = (): boolean =>
  useSyncExternalStore(subscribe, () => document.hasFocus())
